import React from 'react';
import { AuthenticatedPageLayout } from '@/components/layouts/AuthenticatedPageLayout';
import { AuditView } from '@/components/views/AuditView';

export const AuditPage = () => {
	return (
		<AuthenticatedPageLayout>
			<AuditView />
		</AuthenticatedPageLayout>
	);
};
